import { useNavigate } from 'react-router-dom';
import { Button } from '../ui/Button';
import { Dialog } from '../ui/Dialog';

export function ReviewChoiceDialog({ reviewId, proposalId, quotationId, onClose }: {
  reviewId: string;
  proposalId?: string;
  quotationId?: string;
  onClose: () => void;
}) {
  const navigate = useNavigate();
  function go(docs: 'proposal' | 'quotation' | 'both') {
    onClose();
    navigate(`/sales-offers/${reviewId}/review?docs=${docs}`);
  }
  return (
    <Dialog title="Review & issue" onClose={onClose} footer={<Button variant="outline" onClick={onClose}>Cancel</Button>}>
      <p className="text-sm text-[var(--bo-muted)]">Choose what this review is for. You can still change the message and the attachments on the next page. Issue & send sends one email.</p>
      <div className="flex flex-wrap gap-2">
        <Button disabled={!proposalId} onClick={() => go('proposal')}>Proposal</Button>
        <Button disabled={!quotationId} onClick={() => go('quotation')}>Quotation</Button>
        <Button disabled={!proposalId || !quotationId} onClick={() => go('both')}>Both</Button>
      </div>
    </Dialog>
  );
}
